import { render, staticRenderFns } from "./Prefixes.vue?vue&type=template&id=042afa08&scoped=true&"
import script from "./Prefixes.vue?vue&type=script&lang=js&"
export * from "./Prefixes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042afa08",
  null
  
)

export default component.exports